<template>
  <div>
    <div v-bind:class="!record.active ? 'close': ''">
      <div class="record-head">
        <div class="record-left">
          <span class="hourglass_empty">
            <v-icon class="hourglass_empty" size="18"></v-icon>
            <b>Trade Prepare</b>
          </span>
          <span class="text-grey">
            |
            <span @click="emitUser(record.user.username)" class="user-name">{{record.user.username}}</span>
            |
            {{openTime}}
            |
            Status:
            <v-chip
              class="ml-2"
              :color="remain == 'filled' ? '#79C04D' : remain == 'expired' ? '#E62163 ' : remain == 'closed' ? '#E62163 ' : '#808F9C'"
              small
            >
              <span>{{remain}}</span>
            </v-chip>
          </span>
          <div class="record-body">
            <div>
              <b>
                <span
                  :class="record.data.tradeType == 'Long' ? 'up' : 'down'"
                >{{record.data.tradeType}}</span>
              </b>
              |
              <b>{{record.data.strategy}}</b>
              |
              <b>{{record.data.symbol.user}}</b>
              | Zone:
              <b>{{record.data.price}}</b>
            </div>
            <div >
              <v-chip
                small
                v-for="check in record.data.checklist"
                :key="check._id"
                :color="check.selected ? '#4dbac0' : '' "
                class="float-left mr-2 mt-1"
              >
                <v-avatar left>
                  <v-icon size="18" v-if="check.selected">check_box</v-icon>
                  <v-icon size="18" v-else>check_box_outline_blank</v-icon>
                </v-avatar>
                {{check.name}}
              </v-chip>
            </div>
          </div>
        </div>
      </div>
      <div class="record-right">
        <span  @click="routeUser()" class="pointer hover">
        <Avatar
          v-if="record.user.avatar != null"
          class="timeline-avatar"
          :src="`https://tradeinpool.com/upload/${record.user.avatar}.png`"
          :size="40"
        ></Avatar>
        <Avatar v-else class="timeline-avatar" :username="record.user.username" :size="40"></Avatar>
        </span>
        <div class="record-menu">
          <MenuCard :record="record" /> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import MenuCard from "@/components/menuCard";
var moment = require("moment-timezone");
export default {
  components: {
    Avatar,
    MenuCard
  },
  props: ["record"],
  data() {
    return {
      setOpacity: "open",
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.created, this.$store.getters.timezone)
        .fromNow(),
      remain: null //=> '26 years, 9 months, and 4 days'
    };
  },
  methods: {
    emitUser(user){
      this.$emit("emitUser",user)
    },
    routeUser() {
      return this.$router.push({path: "/user/"+this.record.user.username});
    },
    replyName(val) {
      this.$emit("reply_to", val);
    },
    updateTimes() {

      if (this.record.data.status == "pending") {
        if (this.record.data.timeInForce == "Till Cancel") {
          this.remain = "Till Cancel";
        } else {
          let start = moment(); // some random moment in time (in ms)
          let end = moment(this.record.data.expiry); // some random moment after start (in ms)
          let diff = end.diff(start);
          if (diff <= 0) {
            this.remain = "expired";
            this.record.active = false;
            }
          else this.remain = moment.utc(diff).format("HH:mm:ss");
        }
      } else {
        this.remain = this.record.data.status;
      }
    }
  },
  filters: {},
  mounted() {
    // updating record time
    this.updateTimes();
    setInterval(() => {
      this.updateTimes();
    }, 1000);
  },

  computed: {
    openTime() {
      var value = this.record.created;
      var a = moment.tz(value, this.$store.getters.timezone).startOf('day');
      var b = moment.tz(new Date(), this.$store.getters.timezone).startOf('day');
      var diff = a.diff(b, "days"); // =1
      if (diff == 0)
        return  "Today | " + moment
          .tz(value, this.$store.getters.timezone)
          .format("HH:mm");
      else if (diff == -1)
        return  "Yesterday | " + moment
          .tz(value, this.$store.getters.timezone)
          .format("HH:mm");
      else
        return moment
          .tz(value, this.$store.getters.timezone)
          .format("YYYY-MM-DD | HH:mm");
    }
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}

.hourglass_empty {
  color: #4dbac0;
}

.record-body {
  color: white;
  width: auto;
  margin-left: 22px;
}
</style>
